<template>
    <div>
        <slot name="selected-options" :optionsSelected="selectedPreExistentOptions" :inputName="_selectedName">
            <input v-for="(option, index) in selectedPreExistentOptions" :key="`${_selectedName}__prexistent__${index}`" type="hidden" :name="`${_selectedName}`" :id="id" :value="option.value">
        </slot>
        <slot name="new-tags-input"  :selectedNewOptions="selectedNewOptions" :inputName="name"></slot>
        <slot name="destroy-options" :optionsToDestroy="optionsToDestroy" :inputName="name">
            <input v-for="(option, index) in optionsToDestroy" :key="`${name}_destroy__id__prexistent__${index}`" type="hidden" :name="`${_name}[${index}][id]`" :id="id" :value="option.value">
            <input v-for="(option, index) in optionsToDestroy" :key="`${name}_destroy__prexistent__${index}`" type="hidden" :name="`${_name}[${index}][_destroy]`" :id="id" :value="1">
        </slot>
        <vue-multiselect
            ref="multiselect"
            v-model="optionsSelected"
            :options="options"
            :placeholder="placeholder"
            :select-label="'Selecionar'"
            :deselect-label="'Remover'"
            :selected-label="'Selecionado'"
            :tagPlaceholder="'Aperte Enter para criar a Tag'"
            :track-by="trackBy"
            :allow-empty="true"
            :close-on-select="false"
            :blockKeys="blockKeys"
            :searchable="true"
            :multiple="true"
            :taggable="taggable"
            :custom-label="customLabel"
            :openDirection="openDirection"
            @select="_onSelect"
            @open="open"
            @close="close"
            @remove="_onRemove"
            @tag="defaultOnAddTag"
        >
            <template slot="tag" slot-scope="{ option, remove }">
                <slot name="tag" :option="option" :remove="remove"></slot>
            </template>
            <template slot="noOptions">
                <slot name="noOptions"></slot>
            </template>
        </vue-multiselect>
    </div>
</template>

<script>
function defaultCustomLabel(option){
    return option.text
}

export default {
    model: {
        prop: 'values',
        event: 'valuesChanged' 
    },
    props:{
        name: String | Function,
        selectedName: {
            type: String,
            default: null
        },
        id: String,
        values:{
            type: Array,
            default: []
        },
        options: {
            type: Array,
            default: []
        },
        placeholder: {
            type: String,
            default: 'Selecione uma opção'
        },
        trackBy: {
            type: String,
            default: 'value'
        },
        customLabel: {
            type: Function,
            default: defaultCustomLabel
        },
        onAddTag: {
            type: Function,
            default: null
        },
        onSelect: {
            type: Function,
            default: (option, id)=>{}
        },
        open: {
            type: Function,
            default: () => {}
        },
        close: {
            type: Function,
            default: () => {}
        },
        onRemove: {
            type: Function,
            default: null
        },
        valuesMap: {
            type: Function,
            default: null
        },
        taggable: {
            type: Boolean,
            default: true
        },
        blockKeys: {
            type: Array,
            default: () => []
        },
        openDirection: {
            type: String,
            default: ""
        }
    },
    data(){
        return {
            optionsInitial: [],
            optionsSelected: [],
            optionsToDestroy: []

        }
    },
    beforeMount(){
        this.options.forEach((option)=>{
            if(!('new' in option)){
                option.new = false;
            }
        });
        this.values.forEach(option=>{
            var _optionToInsert = option;
            if(this.valuesMap != null){
                _optionToInsert = this.valuesMap(option);
            }
            _optionToInsert = this.options.find(e=>e.value===_optionToInsert.value);
            this.optionsSelected.push(_optionToInsert);
            this.optionsInitial.push(_optionToInsert);
        });
    },
    computed: {
        selectedPreExistentOptions(){
            return this.optionsSelected.filter(option=>option.new===false);
        },
        selectedNewOptions(){
            return this.optionsSelected.filter(option=>option.new===true);
        },
        _selectedName(){
            return this.selectedName || this.name;
        },
        _name(){
            if(typeof this.name === 'string'){
                return this.name;
            } else if(typeof this.name === 'function'){
                return this.name();
            }
        },
    },
    methods: {
        defaultOnAddTag(newTagData){
            if(this.onAddTag != null){
                this.onAddTag(newTagData, this.optionsSelected);
            } else {
                const newTag = {
                    text: newTagData,
                    value: newTagData.substring(0, 2) + Math.floor((Math.random() * 10000000)),
                    new: true
                }
                this.optionsSelected.push(newTag);
            }
        },
        _onRemove(removedOption, id){
            if(this.onRemove != null){
                this.onRemove(removedOption, id);
                this.$emit("valuesChanged", [...this.optionsSelected]);
            } else {
                if(removedOption.new == false && this.isInOptionsInitial(removedOption)){
                    this.optionsToDestroy.push(removedOption);
                }
            }
        },
        _onSelect(option, id){
            this.onSelect(option, id)
            this.$emit("valuesChanged", [...this.optionsSelected, option]);
        },
        isInOptionsInitial(option){
            return this.optionsInitial.map(e=>e.value).includes(option.value);
        },
        activate(){
            this.$refs.multiselect.activate();
        }
    }
}
</script>